var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        [
          _vm._v(
            _vm._s(_vm.$t("BusinessStockDistributionQtyAddSku.title")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.tryCancel } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-position": "top",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.supportWarehouseType"
                        ),
                        prop: "supportWarehouseType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "constant-key": "STOCK_WAREHOUSE_TYPE_SON_4_LIST",
                          disabled: true,
                        },
                        on: { change: _vm.onChangeSupportWarehouseType },
                        model: {
                          value: _vm.form.supportWarehouseType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseType", $$v)
                          },
                          expression: "form.supportWarehouseType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.supportWarehouseId"
                        ),
                        prop: "supportWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectWarehouse", {
                        attrs: { "type-code": ["real"] },
                        on: { change: _vm.onChangeSupportWarehouseId },
                        model: {
                          value: _vm.form.supportWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "supportWarehouseId", $$v)
                          },
                          expression: "form.supportWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.receiveWarehouseType"
                        ),
                        prop: "receiveWarehouseType",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "constant-key": "STOCK_WAREHOUSE_TYPE_SON_3_LIST",
                        },
                        on: { change: _vm.onChangeReceiveWarehouseType },
                        model: {
                          value: _vm.form.receiveWarehouseType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiveWarehouseType", $$v)
                          },
                          expression: "form.receiveWarehouseType",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.receiveWarehouseId"
                        ),
                        prop: "receiveWarehouseId",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: { "option-list": _vm.receiveWarehouseList },
                        on: { change: _vm.onChangeReceiveWarehouseId },
                        model: {
                          value: _vm.form.receiveWarehouseId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "receiveWarehouseId", $$v)
                          },
                          expression: "form.receiveWarehouseId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.categoryId"
                        ),
                        prop: "categoryId",
                      },
                    },
                    [
                      _c("BjGoodsTypeTreeSelect", {
                        attrs: {
                          placeholder: _vm.$t("chooseText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.categoryId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "categoryId", $$v)
                          },
                          expression: "form.categoryId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "BusinessStockDistributionQtyAddSku.skuCode"
                        ),
                        prop: "skuCode",
                      },
                    },
                    [
                      _c("BjInput", {
                        attrs: {
                          maxlength: _vm.MAX_LENGTH.DEFAULT,
                          placeholder: _vm.$t("inputText"),
                          clearable: "",
                        },
                        model: {
                          value: _vm.form.skuCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "skuCode", $$v)
                          },
                          expression: "form.skuCode",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex flex-align-end" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "cyan", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.onSearch()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("queryText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-refresh" },
                  on: {
                    click: function ($event) {
                      return _vm.onReset()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("resetText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { attrs: { type: "flex" } },
        [
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c("p", { staticClass: "title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t(
                        "BusinessStockDistributionQtyAddSku.supplyWarehouseList"
                      )
                    ) +
                    " "
                ),
                _c("span", { staticClass: "tips" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyAddSku.warehouseType"
                        )
                      ) +
                      ":" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyAddSku.realPosition"
                        )
                      ) +
                      "；" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyAddSku.warehouseCode"
                        )
                      ) +
                      ":" +
                      _vm._s(_vm.form.supportWarehouseCode) +
                      "；" +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyAddSku.warehouseName"
                        )
                      ) +
                      ":" +
                      _vm._s(_vm.form.supportWarehouseName) +
                      " "
                  ),
                ]),
              ]),
              _c(
                "vxe-table",
                {
                  ref: "tableSupport",
                  attrs: {
                    data: _vm.tableDataSupport,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                    "row-config": { keyField: "skuCode" },
                    height: "413.55px",
                    "empty-text": _vm.$t("table.emptyText"),
                    "checkbox-config": { checkMethod: _vm.selectableSupport },
                  },
                  on: {
                    scroll: _vm.tableSupportScroll,
                    "checkbox-all": _vm.handleSelectSupportAllEvent,
                    "checkbox-change": _vm.handleSelectionChangeSupport,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "60",
                      align: "center",
                      label: _vm.$t("table.countText"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionQtyAddSku.table.categoryName"
                      ),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionQtyAddSku.table.skuCode"
                      ),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-col", { staticClass: "flex-box-center", attrs: { span: 2 } }, [
            _c(
              "div",
              {
                staticClass: "button-arrow",
                on: { click: _vm.onSupport2ReceiveFn },
              },
              [
                _c("i", { staticClass: "el-icon-arrow-right" }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockDistributionQtyAddSku.distribute")
                    )
                  ),
                ]),
              ]
            ),
            _c(
              "div",
              {
                staticClass: "button-arrow",
                on: { click: _vm.onReceive2SupportFn },
              },
              [
                _c("i", { staticClass: "el-icon-arrow-left" }),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("BusinessStockDistributionQtyAddSku.withdraw")
                    )
                  ),
                ]),
              ]
            ),
          ]),
          _c(
            "el-col",
            { attrs: { span: 11 } },
            [
              _c(
                "p",
                { staticClass: "title" },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "BusinessStockDistributionQtyAddSku.receivingWarehouseList"
                        )
                      ) +
                      " "
                  ),
                  _c("span", { staticClass: "tips" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionQtyAddSku.warehouseType"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.$t(_vm.form.receiveWarehouseTypeName)) +
                        "；" +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionQtyAddSku.warehouseCode"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.form.receiveWarehouseCode) +
                        "；" +
                        _vm._s(
                          _vm.$t(
                            "BusinessStockDistributionQtyAddSku.warehouseName"
                          )
                        ) +
                        ":" +
                        _vm._s(_vm.form.receiveWarehouseName) +
                        " "
                    ),
                  ]),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.setQty } },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("BusinessStockDistributionQtyAddSku.setQty")
                        )
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vxe-table",
                {
                  ref: "tableReceive",
                  attrs: {
                    data: _vm.tableDataReceive,
                    stripe: "",
                    border: "",
                    "header-cell-style": _vm.$rowStyle.DEFAULT,
                    "row-config": { keyField: "skuCode" },
                    height: "400px",
                    "empty-text": _vm.$t("table.emptyText"),
                  },
                  on: {
                    scroll: _vm.tableReceiveScroll,
                    "checkbox-all": _vm.handleSelectReceiveAllEvent,
                    "checkbox-change": _vm.handleSelectionChangeReceive,
                  },
                },
                [
                  _c("vxe-column", {
                    attrs: { type: "checkbox", align: "center", width: "55" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "60",
                      align: "center",
                      label: _vm.$t("table.countText"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "categoryName",
                      align: "center",
                      width: "140",
                      label: _vm.$t(
                        "BusinessStockDistributionQtyAddSku.table.categoryName"
                      ),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "skuCode",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionQtyAddSku.table.skuCode"
                      ),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "qty",
                      align: "center",
                      label: _vm.$t(
                        "BusinessStockDistributionQtyAddSku.table.qty"
                      ),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _c("BjInput", {
                              attrs: { maxlength: _vm.MAX_LENGTH.DEFAULT },
                              model: {
                                value: props.row.qty,
                                callback: function ($$v) {
                                  _vm.$set(props.row, "qty", $$v)
                                },
                                expression: "props.row.qty",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }